exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-card {\r\n    height: calc(100% - 50px);\r\n    width: calc(100% - 50px);\r\n    margin: auto;\r\n    overflow-y: auto;\r\n}\r\n\r\nmat-card-content {\r\n    overflow-x: auto;\r\n}\r\n\r\n#card-content p {\r\n    white-space: pre-line;\r\n}\r\n\r\n.start-scene {\r\n    background-color: #DDF0DE;\r\n}\r\n\r\n.mat-caption {\r\n    text-align: center;\r\n}\r\n\r\n.top-right {\r\n    text-align: right;\r\n    margin-top: -10px;\r\n}\r\n\r\n.interactive {\r\n    position: relative;\r\n    width:24px; height:24px;\r\n    -webkit-transition: color 0.25s;\r\n    transition: color 0.25s;\r\n}\r\n\r\n.interactive:hover {\r\n    cursor: pointer;\r\n    color: #AAAAAA;\r\n}\r\n\r\n.image-container {\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.image-container img {\r\n    margin: auto;\r\n    display: block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/scene/scene.component.css
// module id = ../../../../../src/app/generator/scene/scene.component.css
// module chunks = main